export default {
  title: 'Double bookings',
  table: {
    name: 'Name',
    startDate: 'Start date'
  }
  
}